import { Box, CircularProgress, Container } from "@mui/material";
import iconLogo from "../src/Intelligenic-images/Intelligenic-icon.svg";

const Loading = () => {
    return (
        <Container sx={{ mt: 30 }} maxWidth="sm">
            <Box display="flex" justifyContent="center" alignItems="center">
                <Box sx={{ position: "relative" }}>
                    <Box component="img" alt="Intelligenic" src={iconLogo}></Box>
                    <CircularProgress size="145px" sx={{ color: "#285ee8", position: "absolute", top: -26, left: -35, zIndex: 1 }} />
                </Box>
            </Box>
        </Container>
    );
};

export default Loading;
